export default __webpack_public_path__ + "static/media/ImageArchitect3.db5ecbbd.png";